import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EtudePosturale from './pages/EtudePosturale';
import Location from './pages/Location';
import ReservationEtudePosturale from './pages/ReservationEtudePosturale';
import ReservationLocation from './pages/ReservationLocation';
import ReservationLavage from './pages/ReservationLavage';
import TracesGPX from './pages/TracesGPX';
import LavageVelo from './pages/LavageVelo';
import AtelierVelo from './pages/AtelierVelo';
import DevisAtelier from './pages/DevisAtelier';
import Contact from './pages/Contact';
import Configurateur from './pages/Configurateur';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/etude-posturale" element={<EtudePosturale />} />
          <Route path="/location" element={<Location />} />
          <Route path="/reservation-etude-posturale" element={<ReservationEtudePosturale />} />
          <Route path="/reservation-location" element={<ReservationLocation />} />
          <Route path="/reservation-lavage" element={<ReservationLavage />} />
          <Route path="/traces-gpx" element={<TracesGPX />} />
          <Route path="/lavage-velo" element={<LavageVelo />} />
          <Route path="/atelier-velo" element={<AtelierVelo />} />
          <Route path="/devis-atelier" element={<DevisAtelier />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/configurateur" element={<Configurateur />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
